<template>
  <div class="icon-info" :class="{ isMobile }">
    <div class="img-box">
      <img class="block" :alt="`Icon - ${title}`" :src="`/img/${icon}`" />
    </div>
    <div class="icon-title">{{ title }}</div>
    <div class="icon-text"><slot /></div>
  </div>
</template>
<script>
export default {
  name: "LibHomeSectionIcon",
  props: {
    icon: {
      type: String,
      default: "home-icon-1.svg"
    },
    title: {
      type: String,
      default: ""
    }
  }
};
</script>

<style scoped lang="scss">
.icon-info {
  text-align: center;
  font-weight: 500;
  position: relative;
  img {
    display: block;
    margin: auto;
    height: clamp(88px, 8vw, 150px);
  }
}

.img-box {
  margin-bottom: clamp(20px, 2vw, 36px);
}

.icon-title {
  font-size: 1.25rem;
  margin-bottom: clamp(8px, 1vw, 14px);
}

.icon-text {
  max-width: 230px;
  margin: auto;
}

.isMobile {
  .icon-text {
    font-weight: 400;
  }
}
</style>
